export default __webpack_public_path__ + "static/38-100-f05a59d9deb6e283fab859e3f8c7ddda.jpg";